import { useHistory } from 'react-router-dom';
import IconWebBrowser from '../../../assets/icons/fleet/icon-web_browser.svg';
import Card from '../../../components/Fleets/Card';
import Head from '../../../components/Head';


const OrderChanged = () => {
  const history = useHistory();


  const handleRedirect = () => {
    history.push('/dashboard');
  };

  return (
    <>
        <Head>Frotas</Head>
        <Card
          icon={IconWebBrowser}
          title="Solicitação alterada com sucesso!"
          onButtonClick={handleRedirect}
        />
    </>
  );
};
export default OrderChanged;
